import { Form, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

const StSerialBlock = ({
    form,
    options,
    name,
    submitOnClick,
    data,
    defaultValue
}) => {
    const [selectedVal, setSelectedVal] = useState([]);

    useEffect(() => {
        setSelectedVal(defaultValue || []);
        form.setFieldValue('name', defaultValue || []);
    }, []);

    const submitForm = () => {
        if (submitOnClick) {
            return form.submit();
        }
    }

    const onChange = (e, item, indx) => {
        let newVal = [...selectedVal];
        if (e.ctrlKey || e.metaKey) {
            if (selectedVal.includes(item.val)) {
                newVal = [...selectedVal].filter(x => x !== item.val);
                form.setFieldValue(name, newVal);
                setSelectedVal(newVal);
                submitForm();
                return;
            };
            newVal = [...selectedVal, item.val];
            form.setFieldValue(name, newVal);
            setSelectedVal(newVal);
            submitForm();
            return;
        };
        if (e.shiftKey) {
            if (!selectedVal.length) {
                newVal = [item.val];
                form.setFieldValue(name, newVal);
                setSelectedVal(newVal);
                submitForm();
                return;
            }
            let _selectedValues = [...selectedVal].sort((a, b) => a - b);
            console.log(_selectedValues);
            let initialIndx = options.findIndex(x => x.val === _selectedValues[0]);
            let newSelectedValues = [];
            if (initialIndx < indx) {
                for (var i = initialIndx; i <= indx; i++) {
                    newSelectedValues.push(options[i].val);
                };
            } else {
                for (var i = initialIndx; i >= indx; i--) {
                    newSelectedValues.push(options[i].val);
                };
            };
            newVal = newSelectedValues;
            form.setFieldValue(name, newVal);
            setSelectedVal(newVal);
            submitForm();
            return;
        }
        if (selectedVal.includes(item.val)) {
            newVal = [...selectedVal].filter(x => x !== item.val);
            form.setFieldValue(name, newVal);
            setSelectedVal(newVal);
            submitForm();
            return;
        }
        newVal = [item.val];
        form.setFieldValue(name, newVal);
        setSelectedVal(newVal);
        submitForm();
    }

    const containerStyle = ({ item, index }) => {
        let style = { ...item.blockStyle, background: selectedVal.includes(item.val) ? '#1777ff' : item.blockStyle.background || '#9c9c9c' };
        if (index === 0) {
            style.borderTopLeftRadius = 5;
            style.borderBottomLeftRadius = 5;
        };
        if ((options.length - 1) === index) {
            style.borderTopRightRadius = 5;
            style.borderBottomRightRadius = 5;
        };
        return style;

    }

    return (
        <div className='serial-block' style={{ display: 'flex', overflowX: 'auto' }}>
            <Form.Item hidden={true} name={name}></Form.Item>
            {
                options.length ?
                    options.map((x, i) => (
                        <Tooltip key={`serial-block-${i}`} title={x.title.toolTip}>
                            <div onClick={(e) => onChange(e, x, i)} style={containerStyle({ item: x, index: i })}>
                                {
                                    x.icon ?
                                        <img className='noselect' src={x.icon.img} style={x.icon.style} /> : <></>
                                }
                                <p className='noselect' style={{ width: '100%', margin: 0, ...x.title.style, }}>{x.title.text}</p>
                            </div>
                        </Tooltip>

                    )) : <></>
            }
        </div>
    )
};

export default StSerialBlock;